var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["custom-field-label-pane__editor", _vm.field.field_type] },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.trim",
            value: _vm.value$,
            expression: "value$",
            modifiers: { trim: true },
          },
        ],
        ref: "inputRef",
        staticClass: "pt-ui-input",
        attrs: {
          placeholder: _vm.$t(
            "PtCustomFieldLabelPane.editor.placeholder." + _vm.field.field_type
          ),
          type: "text",
          maxlength: _vm.MAX_URL_LENGTH,
        },
        domProps: { value: _vm.value$ },
        on: {
          blur: [
            _vm.onFinishEdit,
            function ($event) {
              return _vm.$forceUpdate()
            },
          ],
          click: function ($event) {
            $event.stopPropagation()
          },
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.onEnter.apply(null, arguments)
          },
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.value$ = $event.target.value.trim()
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }